package de.kampfkalender.common.data

import kotlinx.serialization.Serializable

@Serializable
data class BroadcastInfo(
    val url: String? = null,
    val free: Boolean = false,
    val freeAfter: Byte? = null,
)